const markup=new WeakMap<Element,string>();
function attributes(target:Element,source:Element,keepFittedStyle=false):void {
  for(const attr of [...target.attributes])if(!source.hasAttribute(attr.name) && !(keepFittedStyle && attr.name==='style'))target.removeAttribute(attr.name);
  for(const attr of [...source.attributes])if(target.getAttribute(attr.name)!==attr.value)target.setAttribute(attr.name,attr.value);
}
function patchHand(target:Element,source:Element):void {
  attributes(target,source,true);
  const old=[...target.childNodes],fresh=[...source.childNodes];
  for(let i=0;i<fresh.length;i++){
    const a=old[i],b=fresh[i]!;
    if(!a){target.appendChild(b);continue;}
    if(a.nodeType!==b.nodeType || (a.nodeType===1 && (a as Element).tagName!==(b as Element).tagName)){a.replaceWith(b);continue;}
    if(a.nodeType===1)patchHand(a as Element,b as Element);
    else if(a.textContent!==b.textContent)a.textContent=b.textContent;
  }
  for(let i=fresh.length;i<old.length;i++)old[i]!.remove();
}
const cardIds=(part:Element)=>[...part.querySelectorAll<HTMLElement>('[data-hand-card]')].map(card=>`${card.dataset.handCard}:${card.parentElement?.className}`).join('|');
/** Keep the live draw subtree attached while applying a room snapshot.
 * Reattaching an animated card forces its browser layers and text to rebuild. */
export function updateTabletopMarkup(root:HTMLElement,html:string):void {
  const template=root.ownerDocument.createElement('template');template.innerHTML=html;
  const previous=root.querySelector<HTMLElement>('.tabletop'),next=template.content.querySelector<HTMLElement>('.tabletop');
  const live=previous?.querySelector<HTMLElement>('.draw-interaction'),host=next?.querySelector<HTMLElement>('[data-draw-host]');
  if(!previous || !next || !live || live.dataset.drawKey!==host?.dataset.drawHost || previous.children.length!==next.children.length){
    if(next)for(const child of next.children)markup.set(child,child.outerHTML);
    root.replaceChildren(template.content);return;
  }
  attributes(previous,next);
  const oldParts=[...previous.children],newParts=[...next.children];
  for(let i=0;i<newParts.length;i++){
    const old=oldParts[i]!,fresh=newParts[i]!;
    if(old.classList.contains('table-stage') && fresh.classList.contains('table-stage'))continue;
    const value=fresh.outerHTML;
    if(markup.get(old)===value)continue;
    // Enabling selection changes button attributes, not the printed faces.
    // Reuse fitted card nodes when the inventory itself has not changed.
    if(old.classList.contains('table-hand') && fresh.classList.contains('table-hand') && cardIds(old)===cardIds(fresh)){
      patchHand(old,fresh);markup.set(old,value);continue;
    }
    const seatScroll=old.classList.contains('table-seats')?old.scrollLeft:0;
    markup.set(fresh,value);old.replaceWith(fresh);
    if(seatScroll)(fresh as HTMLElement).scrollLeft=seatScroll;
  }
  // Alerts and auxiliary dialogs are siblings of the table. They can change
  // without disconnecting the stage or an unchanged hand.
  for(const node of [...root.childNodes])if(node!==previous)node.remove();
  let after=false;
  for(const node of [...template.content.childNodes]){
    if(node===next){after=true;continue;}
    if(after)root.appendChild(node);else root.insertBefore(node,previous);
  }
}
